<div class="modal-content">
  <div class="popup-header">
    <h3>Select File Format</h3>
    <mat-icon class="icon" (click)="closePopup()">close</mat-icon>
  </div>

  <div class="content">
    <p>Please select a file format to download your Cargo Heating Report:</p>

  <div class="button-container">
  <button class="hover-clear btn" (click)="selectOption('csv')">
    CSV
  </button>

  <button class="hover-clear btn" (click)="selectOption('excel')">
    Excel
  </button>
</div>

  </div>
</div>
